import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../servicios';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
  
        let currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.token) {
            if (request.url == "https://www.cloudflare.com/cdn-cgi/trace")
            return    next.handle(request);

              request = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${currentUser.token}`,
                  
                },
              });
         request = request.clone({
           headers: request.headers
             .set('Cache-Control', 'no-cache')
             .set('Pragma', 'no-cache')
             .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
         });



        }

        return next.handle(request);
    }
}